<template>
  <v-card width="390">
    <v-card-title primary-title>
      <v-icon size="36">access_time</v-icon>
      <div>
        <div class="headline mb-3">Limipiar Lista de Vehículos</div>
        <h3 class="mb-2">
          {{
            `${vehicles} ${vehicles === 1 ? 'vehículo' : 'vehículos'} en la lista.`
          }}
        </h3>
        <span>
         {{ `¿Está seguro que quiere borrar ${vehicles === 1 ? 'el vehículo seleccionado' : 'los vehículos seleccionados' }?` }}
        </span>
      </div>
    </v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="error"
        @click="closeMessage"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="primary"
        @click="clearVehiclesAttached"
      >
        Confirmar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'create-mission-view',
    props: {
      vehicles: {
        type: Number,
        default: 0
      }
    },
    methods: {
      clearVehiclesAttached() {
        this.$emit('clearVehiclesFromMessage')
        this.closeMessage()
      },
      closeMessage() {
        this.$emit('closeMessageClearWho')
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Missions/MessageClearWho.vue